<template>
	<div class="sale-person-form">
		<p class="title">Edit Sale Person</p>
		<form v-on:submit.prevent="handleFormSubmitted">
			<div class="input-ctn">
				<div class="label">Name</div>
				<input v-model="name" type="text" class="input" placeholder="Name" />
			</div>
			<button type="submit" class="btn submit">Edit</button>
		</form>
	</div>
</template>

<script>
export default {
	name: "EditCustomerTypeForm",
	props: ["editCustomerType", "customerType"],

	data() {
		return {
			loading: false,
			name: this.customerType.name,
			phoneNumber: this.customerType.phoneNumber,
		};
	},
	methods: {
		async handleFormSubmitted() {
			this.loading = true;
			await this.editCustomerType({ name: this.name, phoneNumber: this.phoneNumber });
			this.loading = false;
		},
	},
};
</script>

<style></style>
